export function pokesSelector(state) {
    return state.pokes
}
 